export enum VatReportType {
  MONTHLY = "Месячный",
  QUARTERLY = "Квартальный",
  YEARLY = "Годовой",
}

export interface IVatReport {
  _id: string;
  reportNumber: string;
  reportType: VatReportType;
  period: {
    startDate: string;
    endDate: string;
  };
  totalSales: {
    amountWithoutVat: { USD: number; UZS: number };
    vatAmount: { USD: number; UZS: number };
    totalAmount: { USD: number; UZS: number };
  };
  totalPurchases: {
    amountWithoutVat: { USD: number; UZS: number };
    vatAmount: { USD: number; UZS: number };
    totalAmount: { USD: number; UZS: number };
  };
  vatLiability: { USD: number; UZS: number };
  vatCredit: { USD: number; UZS: number };
  netVatLiability: { USD: number; UZS: number };
  exchangeRate: number;
  notes?: string;
  isSubmitted: boolean;
  submittedDate?: string;
  createdAt: string;
  updatedAt: string;
} 